/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */

      export type PossibleTypesResultData = {
  "possibleTypes": {
    "Actor": [
      "ApiKeyWithOrganization",
      "FinleyAutomated",
      "UnknownActor",
      "UserActor"
    ],
    "DeliverableArtifactConfig": [
      "CashBalancesFeedConfig",
      "SupplementalTapeConfig",
      "LoanTapeConfig",
      "RepaymentTapeConfig",
      "PortfolioCovenantConfig",
      "OrgProvidedInputConfig",
      "MonthlyServicerReportConfig",
      "MonthlyStatementConfig"
    ],
    "DeliverableArtifactInstanceDownload": [
      "ArtifactInstanceDownloadUrl",
      "ArtifactInstanceDownloadObject"
    ],
    "DeliverableExpectedValueConfig": [
      "DeliverableExpectedValueConfigNoSubmission",
      "DeliverableExpectedValueConfigNonFile",
      "DeliverableExpectedValueConfigFile"
    ],
    "DeliverableSubmission": [
      "DeliverableFileSubmission",
      "DeliverableValueSubmission"
    ],
    "Payload": [
      "FundingRequestPayload",
      "FundingRequestComponentPayload",
      "DeliverablesPayload",
      "IngestionPayload",
      "InsertedDeliverablePayload",
      "UpdatedDeliverableStatusPayload",
      "SubmittedDeliverableSubmissionPayload",
      "VerificationPayload"
    ],
    "PostgresQueryInputValues": [
      "PrincipalBalanceDailyAverageInputValues",
      "TAccountsSumInputValues",
      "OrgProvidedInputInputValues"
    ],
    "ReportTemplate": [
      "BaseReportTemplate"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Actor": [
      "ApiKeyWithOrganization",
      "FinleyAutomated",
      "UnknownActor",
      "UserActor"
    ],
    "DeliverableArtifactConfig": [
      "CashBalancesFeedConfig",
      "SupplementalTapeConfig",
      "LoanTapeConfig",
      "RepaymentTapeConfig",
      "PortfolioCovenantConfig",
      "OrgProvidedInputConfig",
      "MonthlyServicerReportConfig",
      "MonthlyStatementConfig"
    ],
    "DeliverableArtifactInstanceDownload": [
      "ArtifactInstanceDownloadUrl",
      "ArtifactInstanceDownloadObject"
    ],
    "DeliverableExpectedValueConfig": [
      "DeliverableExpectedValueConfigNoSubmission",
      "DeliverableExpectedValueConfigNonFile",
      "DeliverableExpectedValueConfigFile"
    ],
    "DeliverableSubmission": [
      "DeliverableFileSubmission",
      "DeliverableValueSubmission"
    ],
    "Payload": [
      "FundingRequestPayload",
      "FundingRequestComponentPayload",
      "DeliverablesPayload",
      "IngestionPayload",
      "InsertedDeliverablePayload",
      "UpdatedDeliverableStatusPayload",
      "SubmittedDeliverableSubmissionPayload",
      "VerificationPayload"
    ],
    "PostgresQueryInputValues": [
      "PrincipalBalanceDailyAverageInputValues",
      "TAccountsSumInputValues",
      "OrgProvidedInputInputValues"
    ],
    "ReportTemplate": [
      "BaseReportTemplate"
    ]
  }
};
      export default result;
    